import PropTypes from "prop-types"
import React, {useEffect} from "react"
import {connect} from "react-redux"
import {withRouter ,Redirect} from "react-router-dom"

//i18n
import {withTranslation} from "react-i18next"
import AdminSidebarContent from "./AdminSidebarContent"
import SellerSidebarContent from "./SellerSidebarContent";
import {GET_AUTH_USER} from 'helpers/common'
import SalesDeveloperSidebarContent from "./SalesDeveloperSidebarContent"

const Sidebar = props => {   
 
   return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">

          {GET_AUTH_USER()?.user_type === "admin" ? <AdminSidebarContent /> : GET_AUTH_USER()?.user_type === "provider" ? <SellerSidebarContent /> : <SalesDeveloperSidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
